module.exports = __webpack_public_path__ + "static/media/22.4d10c49f.svg";